import { setToken, setUserInfo, getUserInfo, setTokenCC, logout, getToken } from "@/api/login";
import { systemDetial } from "@/api/set";
import Cookies from 'js-cookie';
const userDetailKey = 'p_user_detail'
import router from "@/router";

const state = {
  userInfo: getUserInfo() || {},
  userDetail: Cookies.get(userDetailKey) ? JSON.parse(Cookies.get(userDetailKey)) : {}
}

const mutations = {
  setUserInfo: (state, user_info) => {
    state.userInfo = user_info;
    setUserInfo(user_info)
  },
  setUserDetail: (state, user_detail) => {
    state.userDetail = user_detail
    Cookies.set(userDetailKey, user_detail)
  },
  LOGOUT: (state) => {
    state.userInfo = {}
    state.userDetail = {}
  }
};

const actions = {
  login({ commit }, data) {
    setToken(data.token)
    commit('setUserInfo', data)
    this.dispatch('user/userDetail')
  },
  userDetail({ commit }) {
    systemDetial().then(res => {
      commit('setUserDetail', res.data.info)
    })
  },
  logout({ commit }, passive) {
    if (!passive) {
      logout(getToken())
    }
    commit('LOGOUT')
    setToken()
    setTokenCC()
    setUserInfo()
    Cookies.remove(userDetailKey)
    router.replace({path: '/'})
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
};

